import { generateItems } from 'domain/common';
import { Subject } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Subject', Subject);

export { actions, selectors, reducer };
